import { Avatar, AVATAR_HEIGHT_32 } from '../../Avatar'
import { ICON_HEIGHT_16 } from '../../Icon'
import Text from '../../Text'
import { getTaskIconByApiName } from '../Task.utils'

import * as styles from './TaskTypeField.module.css'

function TaskTypeField({
  className = styles.TaskTypeField,
  value: { icon, name },
  onClick,
}) {
  return (
    <div className={className} onClick={onClick}>
      <Avatar
        Icon={getTaskIconByApiName(icon.name)}
        iconSize={ICON_HEIGHT_16}
        size={AVATAR_HEIGHT_32}
      />
      <div className={styles.textContainer}>
        <Text className={styles.text}>{name}</Text>
      </div>
    </div>
  )
}

export default TaskTypeField
